import { Root, createRoot } from "react-dom/client";
import React from "react";
import menuOverlayService, { MenuToggleVisibilityEvent } from "./MenuOverlayService";
import { HeaderConfiguration } from "./common";
import CategoryMenuModal from "./components/CategoryMenuModal";
import elementService from "@/common/ElementService";
import { assert } from "@/common/assert";

export default new class EshopCategoryMenuService {
    private modalRoot: Root | undefined;

    private readonly headerCategories: HTMLDivElement;
    private readonly headerContainerCategories: HTMLDivElement;

    private headerConfiguration: HeaderConfiguration | undefined;

    constructor() {
        this.headerCategories = elementService.querySelector<HTMLDivElement>("#header-categories");
        this.headerContainerCategories = elementService.querySelector<HTMLDivElement>("#headerContainerCategories");
    }

    public init(headerConfiguration: HeaderConfiguration): void {
        this.headerConfiguration = headerConfiguration;
        elementService.elementQuerySelector<HTMLButtonElement>(this.headerCategories, "button").addEventListener("click", () => this.toggleMenuVisibility());

        menuOverlayService.addEventListener(MenuToggleVisibilityEvent.Type, (event: Event): void => {
            assert(event instanceof MenuToggleVisibilityEvent);

            if (this.modalRoot === undefined) {
                this.headerCategories.classList.toggle("modal-hidden", event.isVisible);
            }
        });
    }

    public toggleMenuVisibility(): void {
        if (this.modalRoot !== undefined) {
            this.hideMenu();
        } else {
            this.showMenu();
        }
    }

    private showMenu(): void {
        if (this.headerConfiguration === undefined) {
            throw new Error("Header configuration is not defined.");
        }

        this.modalRoot = createRoot(this.headerContainerCategories);

        this.modalRoot.render(
            <CategoryMenuModal
                parentSelector={this.headerContainerCategories}
                headerConfiguration={this.headerConfiguration}
                onClose={(): void => this.hideMenu()}
            />,
        );

        this.headerCategories.classList.add("active");

        menuOverlayService.showOverlay(() => this.hideMenu());
    }

    private hideMenu(): void {
        this.modalRoot?.unmount();
        this.modalRoot = undefined;
        this.headerCategories.classList.remove("active");
        menuOverlayService.hideOverlay();
    }
}();
